<template>
  <div :class="['table-list', classes]">
    <div class="table-list__header" v-if="header">
      <div :class="[!mobileHeader ? 'show-for-medium' : '', 'grid-x grid-padding-x align-middle']">
      <div class="cell shrink table-list__check-area" v-if="header.checkbox"
           @click.stop="checkAll">
        <div class="table-list__check">
          <div :class="['checkbox-choice', allChecked ? 'active': '']"></div>
        </div>
      </div>

      <div class="cell shrink table-list__check-area" v-if="header.checkboxColumn">
        <div class="table-list__check">
        </div>
      </div>

      <div class="cell auto">
        <div class="grid-x grid-padding-x">
          <div :class="['cell shrink', column.class]" v-for="(column, key) in header.data"
               :key="key" v-if="column.label !== undefined">
            <div
              :class="['table-list__col table-list__col--header', column.sort ? 'table-list__col--sortable': '']"
              @click="sortTable(column.sort, column.sortStart)" v-if="column.label !== undefined">{{ column.label }}
              <span class="sort-icon"
                    :style="header.currentSort === '-' + column.sort ? 'display: inline;' : ''">
                  <i class="fas fa-sort-down"></i></span>
              <span class="sort-icon"
                    :style="header.currentSort === column.sort ? 'display: inline;' : ''">
                  <i class="fas fa-sort-up"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="table-list__body">
    <div :id="row.post" class="grid-x grid-padding-x align-middle" v-for="(row, key) in data"
         :key="key" @click="post(row.post)">
      <div class="cell shrink table-list__check-area" v-if="row.checkbox && typeof row.checkbox !== 'string'" @click.stop="check($event)">
        <div class="table-list__check">
          <div :class="['checkbox-choice', allChecked ? 'active': '']"
               :data-id="row.checkbox"></div>
        </div>
      </div>

      <div class="cell shrink table-list__check-area" v-if="typeof row.checkbox === 'string' || row.checkbox instanceof String" @click.stop="check($event)">
        <div class="table-list__check">
          <div class="no-check" style="border: 0;" v-html="row.checkbox"></div>
        </div>
      </div>

      <div class="cell auto">
        <div class="grid-x grid-padding-x align-middle">
          <div :class="['cell shrink', column.class]"
               v-for="(column, key) in row.data"
               :key="key" v-if="column.value !== undefined">
            <div :class="['table-list__col', column.type === 'checkbox' ? 'table-list__check-area': '']"
                 v-if="column.value !== undefined">
              <div v-if="column.type !== 'checkbox'">
                  <span :class="[column.span ? column.span : '', column.edit ? 'edit' : '', 'table-list__col__content']"
                        @click.stop="callback(column.callback, column.callbackArgs)" v-if="column.callback">
                    <router-link :to="column.link" v-if="column.link">
                      <span v-html="column.value"></span>
                    </router-link>

                    <span v-html="column.value" v-if="!column.link"></span>
                    <i class="edit-icon far fa-pencil-alt" v-if="column.edit"></i>
                  </span>

                <span :class="[column.span ? column.span : '', column.edit ? 'edit' : '', 'table-list__col__content']"
                      v-if="!column.callback">
                    <router-link :to="column.link" v-if="column.link">
                      <span v-html="column.value"></span>
                    </router-link>

                    <span v-html="column.value" v-if="!column.link"></span>
                    <i class="edit-icon far fa-pencil-alt" v-if="column.edit"></i>
                  </span>

                <div :class="!column.edit.show ? 'hidden': ''" v-if="column.edit">
                  <input type="text" :value="column.edit.value">
                </div>
              </div>

              <div v-if="column.type === 'checkbox'" class="table-list__check"
                   @click.stop="callback(column.callback, column.callbackArgs)">
                <checkbox :active="column.value"></checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Checkbox from './checkbox'

export default {
  components: {Checkbox},
  data: function () {
    return {
      allChecked: false
    }
  },
  props: [
    'classes',
    'header',
    'mobileHeader',
    'data'
  ],
  methods: {
    post: function (data) {
      this.$emit('post', data)
    },
    checkingAll () {
      this.allChecked ? this.allChecked = false : this.allChecked = true
    },
    async checkAll () {
      await this.checkingAll()

      this.$emit('callback', 'itemsSelected', [this.allChecked])
    },
    async checking (e) {
      if (e.target.classList.contains('checkbox-choice')) {
        e.target.classList.toggle('active')
      } else {
        e.target.children[0].classList.toggle('active')
      }
    },
    async check (e) {
      await this.checking(e)

      this.$emit('callback', 'itemsSelected')
    },
    callback (method, args = []) {
      this.$emit('callback', method, args)
    },
    sortTable: function (sort, start) {
      if (sort === undefined) return null

      start = start === undefined ? '' : '-'

      if (this.header.currentSort === '-' + sort) {
        this.header.currentSort = sort
        this.$emit('sort', sort)
      } else if (this.header.currentSort === sort) {
        this.header.currentSort = '-' + sort
        this.$emit('sort', '-' + sort)
      } else {
        this.header.currentSort = start + sort
        this.$emit('sort', start + sort)
      }
    }
  },
  created: function () {
    for (let key in this.data) {
      this.data[key].checked = false
    }
  }
}
</script>

<style lang="scss">
@import '../styles/mixins';
@import '../styles/variables';

.table-list {
  .sort-icon {
    display: none;

    svg {
      position: relative;
    }

    .fa-sort-down {
      top: -3px;
    }

    .fa-sort-up {
      top: 4px;
    }
  }

  &__check-area {
    &.cell {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__check {
    cursor: pointer;
    height: 60px;
    position: relative;
    width: 50px;

    .no-check {
      @include transform(translate(-50%, -50%));
      left: 50%;
      position: absolute;
      top: 50%;
    }

    .checkbox-choice {
      @include transform(translate(-50%, -50%));
      left: 50%;
      position: absolute;
      top: 50%;
    }
  }

  &__header {
    background: $darker2-gray;
    border: 0;
    font-weight: 500;

    & > .grid-x {
      margin: 0;
    }

    .table-list {
      &__check {
        height: 54px;
      }
    }
  }

  &__body {
    border-top: 1px solid $dark-gray;
    min-height: 60px;

    & > .grid-x {
      @include transition(background .1s);
      background: $darker2-gray;
      border-bottom: 1px solid $dark-gray;
      cursor: pointer;
      font-size: 14px;
      line-height: 1.3;
      overflow: hidden;
      margin: 0;

      &:nth-child(odd) {
        background: darken($darker2-gray, 1%);
      }

      &:nth-child(even) {
        background: $darker2-gray;
      }

      &:hover {
        background: lighten($darker2-gray, 5%);
      }

      &:last-child {
        border-bottom: 0;

        &:nth-child(odd) {
          background: $darker2-gray;
        }
      }
    }
  }

  &__col {
    height: 60px;
    min-width: 100px;
    padding: 5px 0;
    position: relative;
    white-space: normal;
    width: 100px;

    &__content {
      @include transform(translateY(-50%));
      line-height: 1.2;
      left: 0;
      top: 50%;
      position: absolute;
      right: 0;

      &.label {
        left: auto;
        right: auto;
      }

      &.fill {
        left: 0;
        right: 0;
      }

      .edit-icon {
        @include transform(translateY(-50%));
        opacity: 0;
        font-size: 12px;
        margin-left: 5px;
        position: absolute;
        right: 10px;
        top: 50%;
      }

      &.edit {
        border-radius: 5px;
        cursor: pointer;
        margin-left: -10px;
        padding: 10px 30px 10px 10px;
        right: auto;

        &:hover {
          background: $darker3-gray;
          color: darken($white, 20%);

          .edit-icon {
            color: darken($white, 20%);
            opacity: 1;
          }
        }
      }
    }

    &--header {
      height: auto;
      padding: 15px 0;
    }

    &--primary {
      width: auto;

      .table-list {
        &__col {
          &__content {
            left: 0;
            right: 0;
          }
        }
      }
    }

    &--sortable {
      cursor: pointer;

      &:hover {
        opacity: .5;
      }
    }

    &.table-list {
      &__check-area {
        padding: 0;

        .table-list__check {
          /*width: auto;*/
        }
      }
    }
  }

  &__icon {
    display: inline-block;
    margin-right: 5px;
    text-align: center;
    width: 20px;
  }

  &__image {
    background: $white;
    border: 1px solid $dark-medium-gray;
    height: 50px;
    margin-right: 15px;
    width: 50px;

    &__inner {
      overflow: hidden;
      padding-bottom: 100%;
      position: relative;

      img {
        bottom: 0;
        left: 0;
        margin: auto;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    &__missing {
      background: $dark-gray;
      height: 48px;
      position: relative;
      text-align: center;

      svg {
        @include transform(translate(-50%, -50%));
        color: $dark-medium-gray;
        font-size: 25px;
        left: 50%;
        position: absolute;
        top: 50%;
      }
    }

    &--rounded {
      border-radius: 999px;
      overflow: hidden;
    }
  }

  &.no-hover {
    .table-list__body {
      & > .grid-x {
        cursor: auto;

        &:nth-child(odd) {
          &:hover {
            background: darken($darker2-gray, 1%);
          }
        }

        &:nth-child(even) {
          &:hover {
            background: $darker2-gray;
          }
        }

        &:last-child {
          &:hover {
            background: $darker2-gray;
          }
        }
      }
    }
  }

  &:last-child {
    border-bottom: 0;

    &:nth-child(odd) {
      background: $darker2-gray;
    }
  }

  .small {
    .table-list {
      &__col {
        min-width: 40px;
        width: 40px;
      }
    }
  }

  .medium {
    .table-list {
      &__col {
        width: 130px;
      }
    }
  }

  .large {
    .table-list {
      &__col {
        width: 170px;
      }
    }
  }

  .xlarge {
    .table-list {
      &__col {
        width: 200px;
      }
    }
  }

  .cell.full {
    flex: 1 1 0px;
    width: auto;

    .table-list {
      &__col {
        width: auto;
      }
    }
  }
}

.light-theme {
  .table-list {
    &__header {
      background: $white;
    }

    &__body {
      background: $white;
      border-color: $light-gray;

      & > .grid-x {
        background: $white;
        border-color: $light-gray;

        &:nth-child(odd) {
          background: darken($white, 1%);
        }

        &:nth-child(even) {
          background: $white;
        }

        &:hover {
          background: darken($white, 5%);
        }

        &:last-child {
          &:nth-child(odd) {
            background: $white;
          }
        }
      }
    }

    &__col {
      &__content {
        &.edit {
          &:hover {
            background: $light-gray;
            color: $darkest-gray;

            .edit-icon {
              color: $darkest-gray;
            }
          }
        }
      }
    }

    &__image {
      border: 1px solid $light-gray;

      &__missing {
        background: $lighter-gray;
      }
    }

    &.no-hover {
      .table-list__body {
        & > .grid-x {
          cursor: auto;

          &:nth-child(odd) {
            background: darken($white, 1%);
          }

          &:nth-child(even) {
            background: $white;
          }

          &:hover {
            background: $white;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/globals/tableList.vue